// Imagen AI integration translations - French
export default {
  generator: {
    title: 'Générateur d\'Images IA',
    tabTitle: 'Générer IA',
    pageTitle: 'Générateur d\'Images IA avec Google Imagen',
    forEntity: 'Générer une image pour',

    // Form fields
    prompt: 'Prompt de l\'Image',
    promptPlaceholder: 'Décrivez l\'image que vous voulez générer...',
    negativePrompt: 'Prompt Négatif',
    negativePromptPlaceholder: 'Ce qu\'il faut éviter : flou, basse qualité, filigrane...',
    description: 'Description de la Pièce Jointe',
    descriptionPlaceholder: 'Description pour cette pièce jointe...',
    aspectRatio: 'Ratio d\'Aspect',
    numberOfImages: 'Nombre d\'Images',
    safetyLevel: 'Niveau de Sécurité',
    autoAttach: 'Attacher automatiquement à l\'entité',
    enhancePrompt: 'Améliorer le prompt avec contexte IA',

    // Actions
    generate: 'Générer avec IA',
    generating: 'Génération...',
    quickPrompt: 'Ajouter Termes de Qualité',
    reset: 'Réinitialiser',
    showAdvanced: 'Afficher Avancé',
    hideAdvanced: 'Masquer Avancé',
    generatedImages: 'Images Générées',

    // Info
    info: 'Google Imagen génère des images de haute qualité à partir de descriptions textuelles en utilisant une IA avancée.',
    feature1: 'Génération d\'images de haute qualité',
    feature2: 'Ratios d\'aspect multiples',
    feature3: 'Filtres de sécurité intégrés'
  },

  // Success messages
  success: {
    generated: '{{count}} image(s) générée(s) avec succès',
    entityGenerated: '{{count}} image(s) générée(s) pour {{entity}}',
    attached: 'Image générée par IA attachée avec succès'
  },

  // Error messages
  errors: {
    promptRequired: 'Veuillez entrer un prompt pour générer une image',
    promptRequiredWhenEnhanceDisabled: 'Un prompt est requis quand l\'amélioration IA est désactivée',
    generationFailed: 'Échec de la génération d\'image',
    invalidEntity: 'Type d\'entité ou ID invalide',
    configLoadFailed: 'Échec du chargement de la configuration Imagen'
  },

  // Info messages
  info: {
    processing: 'Votre image est en cours de génération avec Google Imagen...',
    qualityNote: 'Les paramètres de qualité supérieure peuvent prendre plus de temps à générer'
  }
};
